import React from "react";

const LocationsList = () => {
  return <div className="p-10 bg-gray-100">LocationsList</div>;
};

export default LocationsList;
